import Api from '../api';
import {
  ADMIN_GET_OPS_DASHBOARD,
  ADMIN_GET_OPS_DASHBOARD_URL,
  ADMIN_GET_STUCK_QUEUE_AGGREGATE,
  ADMIN_GET_STUCK_QUEUE_AGGREGATE_URL
} from '../lib/constant';
import {handleAPIDispatch} from '../lib/utils';

// AdminGetOpsDashboard — flat time-series rollup from dashboard_metrics
// where view_type='ops'.
//
// params:
//   - startTime  ISO-8601 (required, inclusive)
//   - endTime    ISO-8601 (required, exclusive)
//   - bucketType "hour" | "day" | "month" (required)
//   - tenantId   optional — empty → fleet-wide aggregation
//   - messageType optional SMS type (Transactional|Promotional|OTP|Marketing|
//                 Service|International). Empty/"all" → no filter (every type,
//                 rows stay grouped by message_type).
export function adminGetOpsDashboard({startTime, endTime, bucketType, tenantId, messageType}) {
  const params = {
    start_time: startTime,
    end_time: endTime,
    bucket_type: bucketType
  };
  if (tenantId) params.tenant_id = tenantId;
  if (messageType && messageType.toLowerCase() !== 'all') params.message_type = messageType;
  const request = Api.get(ADMIN_GET_OPS_DASHBOARD_URL, true, params);
  return handleAPIDispatch(request, ADMIN_GET_OPS_DASHBOARD);
}

// AdminGetStuckQueueAggregate — QUEUED-vs-SUBMIT count breakdown per
// (tenant_id, hour-bucket). Caller pivots client-side across status_code
// to compute in_flight = Σ QUEUED − Σ (SUBMIT_SUCCESS + SUBMIT_FAILED).
//
// params:
//   - windowMinutes  optional, server clamps to [15, 1440], default 60
//   - tenantId       optional — empty → fleet-wide
export function adminGetStuckQueueAggregate({windowMinutes, tenantId} = {}) {
  const params = {};
  if (windowMinutes) params.window_minutes = windowMinutes;
  if (tenantId) params.tenant_id = tenantId;
  const request = Api.get(ADMIN_GET_STUCK_QUEUE_AGGREGATE_URL, true, params);
  return handleAPIDispatch(request, ADMIN_GET_STUCK_QUEUE_AGGREGATE);
}
